import html from "./images/html-5.svg";
import css from "./images/css3.svg";
import javascript from "./images/javascript.svg";
import bootstap from "./images/bootstrap-4.svg";
import react from "./images/react.svg";
import react_router from "./images/react-router.svg";
import redux from "./images/redux.svg";
import material_ui from "./images/material-ui-1.svg";
import react_bootstrap from "./images/react-bootstrap.svg";
import nodejs from "./images/nodejs.svg";
import express from "./images/express.svg";
import mongodb from "./images/mongodb.svg";
import git_icon from "./images/git-icon.svg";
import github from "./images/github.svg";
import github_api from "./images/github-api.svg";
import heroku from "./images/heroku.svg";
import firebase from "./images/firebase1.png";
import python from "./images/python.svg";
import shopsky from "./images/experience/shopsky.jpg";
import nagarro from "./images/experience/nagarro.png";
import todo from "./images/todo.png";
import todoimg from "./images/todoimg.png";
import corona1 from "./images/coronaimg.png";
import corona2 from "./images/coronaimg2.png";
import snake from "./images/snake.jpg";
import pygame from "./images/pygame_logo.gif";
import covidApp from "./images/covidapp.png";
import gmailClone from "./images/gmail_clone.png";
import netflixClone from "./images/netflix.png";
import store from "./images/store.png";

export const dataBase = {
  frontend: [
    {
      link: "https://en.wikipedia.org/wiki/HTML5",
      imgAltText: "HTML5",
      imgSrc: html,
      skillName: "HTML5",
    },
    {
      link: "https://medium.com/beginners-guide-to-mobile-web-development/whats-new-in-css-3-dcd7fa6122e1",
      imgAltText: "CSS3",
      imgSrc: css,
      skillName: "CSS3",
    },
    {
      link: "https://www.javascript.com/",
      imgAltText: "JAVASCRIPT",
      imgSrc: javascript,
      skillName: "JavaScript",
    },
    {
      link: "https://getbootstrap.com/",
      imgAltText: "Bootstap",
      imgSrc: bootstap,
      skillName: "Bootstrap",
    },
    {
      link: "https://reactjs.org/",
      imgAltText: "ReactJS",
      imgSrc: react,
      skillName: "ReactJS",
    },
    {
      link: "https://reacttraining.com/react-router/",
      imgAltText: "React Router",
      imgSrc: react_router,
      skillName: "React Router",
    },
    {
      link: "https://redux.js.org/",
      imgAltText: "Redux",
      imgSrc: redux,
      skillName: "Redux",
    },
    {
      link: "https://material-ui.com/",
      imgAltText: "Material-UI",
      imgSrc: material_ui,
      skillName: "Material-UI",
    },
    {
      link: "https://react-bootstrap.github.io/",
      imgAltText: "React Bootstrap",
      imgSrc: react_bootstrap,
      skillName: "React Bootstrap",
    },
  ],
  backend: [
    {
      link: "https://nodejs.org/en/",
      imgAltText: "Node JS",
      imgSrc: nodejs,
      skillName: "Node JS",
    },
    {
      link: "https://expressjs.com/",
      imgAltText: "Express",
      imgSrc: express,
      skillName: "Express",
    },
  ],
  hosting: [
    {
      link: "https://firebase.google.com/docs",
      imgAltText: "Firebase",
      imgSrc: firebase,
      skillName: "Firebase",
    },
    {
      link: "https://www.heroku.com/",
      imgAltText: "Heroku",
      imgSrc: heroku,
      skillName: "Heroku",
    },
    {
      link: "https://pages.github.com/",
      imgAltText: "Github Pages",
      imgSrc: github,
      skillName: "Github Pages",
    },
  ],
  languages: [
    {
      link: "https://www.python.org/",
      imgAltText: "Python",
      imgSrc: python,
      skillName: "Python",
    },
    {
      link: "https://www.javascript.com/",
      imgAltText: "JAVASCRIPT",
      imgSrc: javascript,
      skillName: "JavaScript",
    },
  ],
  databases: [
    {
      link: "https://www.mongodb.com/",
      imgAltText: "MongoDB",
      imgSrc: mongodb,
      skillName: "MongoDB",
    },
    {
      link: "https://firebase.google.com/docs",
      imgAltText: "Firebase",
      imgSrc: firebase,
      skillName: "Firebase",
    },
  ],
  version_conrol: [
    {
      link: "https://git-scm.com/",
      imgAltText: "Git",
      imgSrc: git_icon,
      skillName: "Git",
    },
  ],
  experiences: [
    {
      link: "https://www.nagarro.com/",
      imgAltText: "Nagarro",
      imgSrc: nagarro,
      title: "Associate Engineer",
      technologies: "Angular, React, Dot Net, SQL",
      duration: "Sep 2022 - Present",
      description:["Developed various features related to the e-invoicing portal that allows businesses to manage their invoices, purchase orders, and other procurement-related documents electronically. Tech Stack: .NET Core, Angular, React, Web-APIs, HTML5, JavaScript, CSS3, Git.",
      "Developed RESTful web services and APIs to facilitate seamless communication between frontend and backend systems, ensuring efficient data exchange and enhancing user experience.",
      "Delivered assigned tasks (on .NET Core, Angular, Web-APIs, VB .NET, SQL, and React) on time with quality work and unit tests including 90% code coverage.",
      "Participated in requirement analysis and estimation, identifying optimal solutions, and delivering detailed analysis reports.",
      "Conducted thorough unit testing post-feature development, ensuring robust code quality."]
    },
    {
      link: "https://www.nagarro.com/",
      imgAltText: "Nagarro",
      imgSrc: nagarro,
      title: "Associate Engineer Trainee",
      technologies: "HTML, CSS, JavaScript, Angular, ReactJS, NodeJS, Dot Net, Sql",
      duration: "Mar 2022 - Sep 2022",
      description:["Gone through the Nagarro training program which is an intense FullStack Training Bootcamp on Angular, React, SQL, NodeJs and Dotnet(MVC).","Developed REST APIs using DotNet while building a FullStack demo website just like Twitter."]
    },
    // {
    //   link: "https://www.shopsky.in/",
    //   imgAltText: "Shopsky",
    //   imgSrc: shopsky,
    //   title: " Web Developer Intern",
    //   technologies: "HTML,CSS,JavaScript,React Js",
    //   duration: "Jan 2021 - Jan 2021 (1 Month)",
    //   description:["Design some webpages for their website which helps me to work as a team with other developers.","Solve some bugs in their website which improves user experience"],
        
    //   certificates:
    //     "https://drive.google.com/drive/folders/1_3rbRYGcx8ACW0BpPZ7RIWL6x0zCf5xw",
    // },
  ],
  // PROJECTS
  projects: [
    {
      // live: "https://netflix-clone-c5cfc.web.app/",
      // source_code: "https://github.com/ParasPandey/Netflix-Clone",
      imgAltText: "netflix",
      imgSrc: store,
      project_name: "STYLE LOFT - ONLINE STORE",
      technologies: [
        {
          name: "React JS",
          imgAltText: "react",
          imgSrc: react,
        },
        {
          name: "Redux",
          imgAltText: "redux",
          imgSrc: redux,
        },
        {
          name: "NodeJs",
          imgAltText: "NodeJs",
          imgSrc: nodejs,
        },
        {
          name: "ExpressJs",
          imgAltText: "ExpressJs",
          imgSrc: express,
        },
        {
          name: "MongoDB",
          imgAltText: "MongoDB",
          imgSrc: mongodb,
        },
      ],
      duration: "8/2022",
      description:
        "An online store where users can get the most stylish clothes of many popular brands with user-friendly UI.",
      features: [
        {
          feature:
            "Design and develop the whole database schema to store the products, users, orders, etc.",
        },
        {
          feature: "Using React, develop the whole UI of the application and make it user-friendly. Make Rest APIs in NodeJs which helps to store, fetch, update, and delete data on the database.",
        },
        {
          feature: "Implemented Razorpay to application for payment.",
        },
        {
          feature: "Implemented the email sending service to the user after a user successfully registered to the application.",
        },
      ],
    },
    {
      live: "https://netflix-clone-c5cfc.web.app/",
      source_code: "https://github.com/ParasPandey/Netflix-Clone",
      imgAltText: "netflix",
      imgSrc: netflixClone,
      project_name: "Netflix Clone",
      technologies: [
        {
          name: "HTML5",
          imgAltText: "html",
          imgSrc: html,
        },
        {
          name: "CSS3",
          imgAltText: "css3",
          imgSrc: css,
        },
        {
          name: "JavaScript",
          imgAltText: "javascript",
          imgSrc: javascript,
        },
        {
          name: "React JS",
          imgAltText: "react",
          imgSrc: react,
        },
        {
          name: "Material-UI",
          imgAltText: "material-ui",
          imgSrc: material_ui,
        },
        {
          name: "Redux",
          imgAltText: "redux",
          imgSrc: redux,
        },
        {
          name: "React Bootstrap",
          imgAltText: "bootstrap",
          imgSrc: react_bootstrap,
        },
        {
          name: "Firebase",
          imgAltText: "firebase",
          imgSrc: firebase,
        },
      ],
      duration: "8/2021",
      description:
        "A web app that fetch data from tmdb api and displays different categories of movies, web-series and shows.",
      features: [
        {
          feature:
            "Sign up / Login / Logout Functionality (Using Google Account (Firebase))",
        },
        {
          feature: "Real-time database which store user profile and current activated plan",
        },
        {
          feature: "Fully Responsive in nature",
        },
        {
          feature: "Shows full detail about movie or show along with their trailer and additional videos.",
        },
      ],
    },
    {
      live: "https://clone-5bbc1.web.app/",
      source_code: "https://github.com/ParasPandey/Gmail_Clone",
      imgAltText: "gmail",
      imgSrc: gmailClone,
      project_name: "Gmail Clone",
      technologies: [
        {
          name: "HTML5",
          imgAltText: "html",
          imgSrc: html,
        },
        {
          name: "CSS3",
          imgAltText: "css3",
          imgSrc: css,
        },
        {
          name: "JavaScript",
          imgAltText: "javascript",
          imgSrc: javascript,
        },
        {
          name: "React JS",
          imgAltText: "react",
          imgSrc: react,
        },
        {
          name: "Material-UI",
          imgAltText: "material-ui",
          imgSrc: material_ui,
        },
        {
          name: "Redux",
          imgAltText: "redux",
          imgSrc: redux,
        },
        {
          name: "React Bootstrap",
          imgAltText: "bootstrap",
          imgSrc: react_bootstrap,
        },
        {
          name: "Firebase",
          imgAltText: "firebase",
          imgSrc: firebase,
        },
      ],
      duration: "6/2021",
      description:
        "This is an App created with the help of React,Redux and firebase as a main tech. In this app, users can log in using their Google account and send real-time emails to anyone like the actual Gmail app. Right now users can only send text mail.",
      features: [
        {
          feature:
            "Login / Logout Functionality (Using Google Account (Firebase))",
        },
        {
          feature: "Real-time feature of sending email to any user",
        },
        {
          feature: "Respoisive Design",
        },
        {
          feature: "Real-time database (using Firebase)",
        },
        {
          feature: "Try to implement Dark mode also.",
        },
      ],
    },
    {
      live: "https://covid-19-tracker-1e3fb.web.app/",
      source_code: "https://github.com/ParasPandey/Corona19-Tracker",
      imgAltText: "corona",
      imgSrc: covidApp,
      project_name: "Covid19 App",
      technologies: [
        {
          name: "HTML5",
          imgAltText: "html",
          imgSrc: html,
        },
        {
          name: "CSS3",
          imgAltText: "css3",
          imgSrc: css,
        },
        {
          name: "JavaScript",
          imgAltText: "javascript",
          imgSrc: javascript,
        },
        {
          name: "React JS",
          imgAltText: "react",
          imgSrc: react,
        },
        {
          name: "Material-UI",
          imgAltText: "material-ui",
          imgSrc: material_ui,
        },
        {
          name: "Firebase",
          imgAltText: "firebase",
          imgSrc: firebase,
        },
      ],
      duration: "3/2021",
      description:
        "This is an App created with the help of React as a main tech.In this app we can see the total number of corona cases across all countries with total number of cases and also it display the globe in which we toggle from one country to another country with  the help of dropdown.It also display the density of covid positive patients in map.This app also display a chart which gives the estimate of covid patient across world. Chart.js: To display Chart and  React-leaflet: To display Map",
      features: [
        {
          feature:
            "Keeps track of total number of corona cases across all countries and display it in a form of table",
        },
        {
          feature:
            "Using Chart and Maps to display the total corona cases in a particular country in beautiful way",
        },
        {
          feature: "Respoisive Design",
        },
      ],
    },
    {
      live: "https://to-do-list-f841f.web.app/",
      imgAltText: "todo",
      imgSrc: todoimg,
      project_name: "React Todo App",
      technologies: [
        {
          name: "HTML5",
          imgAltText: "html",
          imgSrc: html,
        },
        {
          name: "CSS3",
          imgAltText: "css3",
          imgSrc: css,
        },
        {
          name: "React JS",
          imgAltText: "react",
          imgSrc: react,
        },
        {
          name: "Material-UI",
          imgAltText: "material-ui",
          imgSrc: material_ui,
        },
        {
          name: "Firebase",
          imgAltText: "firebase",
          imgSrc: firebase,
        },
      ],
      duration: "11/2020",
      description:
        " This is a Todo App created with React and Material UI that keeps a track of your Todos",
      features: [
        {
          feature: "Keeps track of your Todos",
        },
        {
          feature: "Powered by React and Material UI",
        },
        {
          feature: "Respoisive Design",
        },
      ],
    },
    {
      live: "https://paraspandey.github.io/#home",
      source_code: "https://github.com/ParasPandey/ParasPandey.github.io",
      imgAltText: "corona",
      imgSrc: corona2,
      project_name: "Corona Virus Tracker",
      technologies: [
        {
          name: "HTML5",
          imgAltText: "html",
          imgSrc: html,
        },
        {
          name: "CSS3",
          imgAltText: "css3",
          imgSrc: css,
        },
        {
          name: "JavaScript",
          imgAltText: "javascript",
          imgSrc: javascript,
        },
        {
          name: "Bootstrap",
          imgAltText: "Bootstrap",
          imgSrc: bootstap,
        },
      ],
      duration: "9/2020",
      description:
        "This is a website created with HTML,CSS,JavaScript and Bootstrap which gives information about the number of coronavirus cases across states and countries with total number of deaths and recoveries.",
      features: [
        {
          feature:
            "Keeps track of total number of corona cases across all countries and all states of India",
        },
        {
          feature: "Powered by JavaScript and Bootstrap",
        },
        {
          feature: "Respoisive Design",
        },
      ],
    },
    // {
    //   source_code: "https://github.com/ParasPandey/Hungry-Snake-Game",
    //   imgAltText: "hungry snake",
    //   imgSrc: snake,
    //   project_name: "Hungry Snake Game",
    //   technologies: [
    //     {
    //       name: "Python",
    //       imgAltText: "python",
    //       imgSrc: python,
    //     },
    //     {
    //       name: "Pygame",
    //       imgAltText: "pygame",
    //       imgSrc: pygame,
    //     },
    //   ],
    //   duration: "8/2020",
    //   description: " A Simple snake game for kids using Python and Pygame.",
    //   features: [
    //     {
    //       feature:
    //         "Fun Snake Game with all features of moving in any direction",
    //     },
    //     {
    //       feature: "Eat as much as food and try to beat highscore.",
    //     },
    //     {
    //       feature: "Difficulty(speed of snake) increases as much you eat",
    //     },
    //   ],
    // },
  ],
};
